module.exports = __webpack_public_path__ + "media/seher_1.1d.2ceb99da.mp3";